
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuardService } from './core/can-deactivate-guard.service';
import { NotfoundComponent } from './core/notfound/notfound.component';
import { OncologyFormComponent } from './oncologyform/oncologyform.component';
import { SubmissionSuccessComponent } from './submissionsuccess/submissionsuccess.component';


const routes : Routes = [ 
  { path: '', redirectTo: 'oncologyform', pathMatch: 'full' },
{path: 'oncologyform', component: OncologyFormComponent , canDeactivate: [CanDeactivateGuardService] },
{path: 'SubmissionSuccess', component: SubmissionSuccessComponent , canDeactivate: [CanDeactivateGuardService] },

    {path: '**', component: NotfoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
      scrollPositionRestoration: "top"
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
